import { createRoot } from 'react-dom/client';
import React from 'react'

import { App } from '@ui/app';

import { BrowserRouter } from 'react-router-dom';

const domNode = document.getElementById('root');

const root = createRoot(domNode);


if (domNode) root.render(<React.StrictMode><BrowserRouter><App /></BrowserRouter></React.StrictMode>);
